// extracted by mini-css-extract-plugin
export default {"fallback":"RouteFallback_fallback__vh4kU"};